import { Star } from "lucide-react";

const GOOGLE_REVIEW_URL =
  process.env.REACT_APP_GOOGLE_REVIEW_URL ||
  "https://www.google.com/search?q=Swiss+Premium+Insurance+avis";

export default function GoogleStars({ rating = 4.9, reviews = 187, compact = false }) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;
  return (
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-stars-badge"
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full bg-white border border-slate-200 hover:border-slate-300 shadow-sm transition-all ${
        compact ? "text-xs" : "text-sm"
      }`}
    >
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden>
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.12c-.22-.66-.35-1.36-.35-2.12s.13-1.46.35-2.12V7.04H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.96l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
      </svg>
      <div className="flex items-center gap-1">
        {Array.from({ length: 5 }).map((_, i) => {
          const filled = i < full || (i === full && hasHalf);
          return (
            <Star
              key={i}
              className={filled ? "fill-[#FBBC05] text-[#FBBC05]" : "text-slate-300"}
              strokeWidth={1.5}
              size={compact ? 12 : 14}
            />
          );
        })}
      </div>
      <span className="font-semibold text-slate-900">{rating.toFixed(1)}</span>
      <span className="text-slate-500">· {reviews} avis Google</span>
    </a>
  );
}
